import { j as t } from "../../../../node_modules/react/jsx-runtime.js";
import { Typography as s } from "../../Typography/Typography.js";
import i from "../../Badge/Badge.js";
import { memo as d } from "react";
const n = ({ item: r }) => {
  var o;
  return /* @__PURE__ */ t.jsxs("div", { className: "flex items-center gap-075 py-075", children: [
    /* @__PURE__ */ t.jsx(
      s,
      {
        text: r.header.title,
        variant: "body-new/medium"
      }
    ),
    r.variant === "inline" && /* @__PURE__ */ t.jsx(t.Fragment, { children: ["shortDescription", "subtitle"].map(
      (e) => r.header[e] && /* @__PURE__ */ t.jsx(
        s,
        {
          text: r.header[e],
          variant: e === "shortDescription" ? "body-new/regular" : "body-new/medium",
          textColor: e === "shortDescription" ? "color/fg/lighter" : "color/fg/bold"
        },
        e
      )
    ) }),
    ((o = r == null ? void 0 : r.header) == null ? void 0 : o.badges) && r.header.badges.slice(0, 2).map((e, a) => /* @__PURE__ */ t.jsx(
      i,
      {
        ...e,
        size: "small"
      },
      a
    ))
  ] });
}, x = d(n);
export {
  x as default
};
//# sourceMappingURL=ActivityItemHeader.js.map
